import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

import getExpirationDate from "../../lib/utils/getExpirationDate";

function EguOutSourcingInputInspectionInputButton(props) {
    const { id, schema, grid, refresh, onSuccess, onFailure, customizeErrorMsgCallback, ...others } = props;

    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [modifiedSchema, setModifiedSchema] = useState();
    const [formData, setFormData] = useState();
    
    useEffect(() => {
        let modifiedSchema = cloneDeep(schema);

        if (modifiedSchema) {
            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "wareHouseCode":
                        column.hideInForm = false;
                        column.required = true;
                        
                        break;

                    case "manufacturedDate":
                        column.hideInForm = false;
                        column.defaultValue = new Date()
                        
                        break;

                    case "inputDate":
                        column.hideInForm = false;
                        column.formItemType = "date";
                        break;

                    case "expirationDate":
                        column.hideInForm = false;
                        column.defaultValue = getExpirationDate(null, new Date())
                        
                        break;

                    

                    default:
                        column.disabled = true;
                        column.required = false;
                        break;
                }
            }

            setModifiedSchema(modifiedSchema);
        }
    }, [schema]);


    const onOpen = () => {
        
        if (grid) {
            const selectedGridItem = {...grid.selectedItems[0]}
            setFormData({...grid.selectedItems[0], 'manufacturedDate':new Date(), 'expirationDate':getExpirationDate(selectedGridItem['standardExpirationDate'], new Date())});
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onInputSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <React.Fragment>
            <ActionButtonLayout id={id + "-input-button"} onClick={onOpen} {...others}>
                {t("buttonName.input")}
            </ActionButtonLayout>
            <AutoFormDialog
                id={id + "-input-dialog"}
                mode="edit"
                formId={id + "-input-form"}
                title={schema ? t(`dialog.title.${schema.name}.input`) : ""}
                schema={modifiedSchema}
                modifyUrlCallback={(url) => `/api/${schema.name}/doInput`}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onInputSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </React.Fragment>
    );
}

export default EguOutSourcingInputInspectionInputButton;
